import { LoggedUserDTO } from './LoggedUserDTO'

// Mirrors common.ErrWebAccessDenied in the backend.
export const WEB_ACCESS_DENIED = 'web_access_denied'

export type LoginResult = {
  user?: LoggedUserDTO
  webAccessDenied?: boolean
}
